import { useContext, useEffect, useState } from 'react';

import { DataContext } from 'providers/data';

import SingleCard from './SingleCard';
import { Typography } from '@mui/material';

import { itemProduct } from 'utils/typeServices';
import { LoadConfig } from 'utils/loadConfig';
import { ParseQuotation } from 'utils/getIconIndividualServices';

import { ContainerServices, ContainerUl, Nav } from './styles';

const IndividualServices = () => {
    const { dataQuoteListservices } = useContext(DataContext);
    const [itemsAdditionalServices, setItemsAdditionalServices] = useState<Array<itemProduct>>([]);

    useEffect(() => {
        if (dataQuoteListservices) {
            setItemsAdditionalServices([]);
            let array: itemProduct[] = [];

            const PLATINUM_PRODUCTS = LoadConfig().REACT_APP_PLATINUM_PRODUCTS;

            // eslint-disable-next-line array-callback-return
            dataQuoteListservices.cotacaO_ITEMS.map(({ nR_TIPO_PRODUTO, nM_PRODUTO, cD_PRODUTO }, index) => {
                if (nR_TIPO_PRODUTO === 13 && !nM_PRODUTO?.includes("Pacote") && cD_PRODUTO !== 1812 && !PLATINUM_PRODUCTS.includes(cD_PRODUTO)) {
                    array.push(dataQuoteListservices.cotacaO_ITEMS[index]);
                }
            });

            const arraySort = array.sort((a, b) => parseFloat(a.vL_TOTAL.split(' ')[1].replace(',', '.')) - parseFloat(b.vL_TOTAL.split(' ')[1].replace(',', '.')));
            setItemsAdditionalServices(arraySort);
        }
    }, [dataQuoteListservices]);

    const splitString = (total: string) => {
        const vlTotal = total?.split(' ');

        return vlTotal[1];
    }

    return (
        <ContainerServices>
            <Typography variant='h5' marginBottom='1.81rem'>
                Fique mais protegido com os nossos
                <strong> serviços adicionais <span style={{ color: '#17A7E0' }}>PAGANDO MENOS</span>:</strong>
            </Typography>

            <div>
                <Nav>
                    <Typography fontSize={14} fontWeight={600}>
                        <span>Serviços</span>Mensalidade*
                    </Typography>
                </Nav>
                <ContainerUl>
                    {itemsAdditionalServices?.map(({ nM_PRODUTO, nR_PORCENTAGEM_INDENIZACAO, vL_TOTAL, cD_PRODUTO, dS_PRODUTO, cD_COTACAO_ITEM, nR_TIPO_PRODUTO, vL_COMISSAO_MINIMO }, index) => (
                        parseFloat(vL_TOTAL.split(' ')[1].replace(',', '.')) !== 0 &&
                        <SingleCard
                            key={index}
                            cdQuotationItem={cD_COTACAO_ITEM}
                            codProductSingle={cD_PRODUTO}
                            nrTypeProduct={nR_TIPO_PRODUTO}
                            VL_COMISSAO={vL_COMISSAO_MINIMO}
                            icon={ParseQuotation(cD_PRODUTO)}
                            title={nM_PRODUTO}
                            price={splitString(vL_TOTAL)}
                            description={dS_PRODUTO[0]}
                            nR_PORCENTAGEM_INDENIZACAO={nR_PORCENTAGEM_INDENIZACAO}
                        />
                    ))}
                </ContainerUl>
            </div>
        </ContainerServices>
    )
}

export default IndividualServices;